// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader-balls{display:flex;justify-content:center;align-items:center;svg{display:flex;justify-content:center;align-items:center;width:15vw}}", ""]);
// Exports
module.exports = exports;
